import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import Select from "react-select";

const FormGroup = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  error,
  type = "text",
  as = "input",
  options = [],
  disabled = false,
  additionalProps = {},
}) => {
  const Component = as; // Bisa berupa "input", "textarea", atau "select"
  const [isEditing, setIsEditing] = useState(false);

  const formatRupiah = (value) => {
    return new Intl.NumberFormat("id-ID").format(value);
  };

  // Fungsi utilitas
  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  const handleFocus = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  return (
    <div className="row mb-3 align-items-center">
      <label
        htmlFor={id}
        className="col-sm-4 col-form-label d-flex justify-content-end"
        style={{ fontSize: "14px" }}
      >
        {label}:
      </label>
      <div className="col-sm-8">
        {as === "select" ? (
          <Select
            id={id}
            name={id}
            value={value}
            onChange={onChange}
            options={options}
            className={clsx(
              error && "is-invalid",
              "gotra-form-control rounded-1"
            )}
            placeholder={placeholder}
            isDisabled={disabled}
            {...additionalProps}
          />
        ) : (
          <Component
            id={id}
            name={id}
            type={type}
            value={type === "number" && !isEditing ? formatRupiah(value) : value}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder={placeholder}
            className={clsx(
              "form-control gotra-form-control rounded-1",
              error && "is-invalid"
            )}
            disabled={disabled}
            {...additionalProps}
          />
        )}
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

FormGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  type: PropTypes.string,
  as: PropTypes.oneOf(["input", "textarea", "select"]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  disabled: PropTypes.bool,
  additionalProps: PropTypes.object,
};

export default FormGroup;
